import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import Skeleton from '@empiriecom/module-components/Skeleton';

const ElementSkeleton = styled(Skeleton)`
  margin: 1.25rem 0;
  padding: 0.5rem 0;
  border-radius: 5px;
  @media only screen and (max-width: 500px) {
    margin: 1.25rem 0.5rem;
  }
`;

/**
 * This is the detail view skeleton. It provides a skeleton view of the detail view
 * elements until all information is loaded and ready to be displayed. It is available
 * for the desktop as well as the mobile view.
 */
export const InstallmentCalculatorElementSkeleton: FunctionComponent = (): JSX.Element => (
  <ElementSkeleton height="7rem" />
);

export default InstallmentCalculatorElementSkeleton;
